export const ACTIVITIES_LOG_REQUEST = "ACTIVITIES_LOG_REQUEST";
export const ACTIVITIES_LOG_REQUEST_SUCCEEDED = "ACTIVITIES_LOG_REQUEST_SUCCEEDED";
export const ACTIVITIES_LOG_REQUEST_FAILED = "ACTIVITIES_LOG_REQUEST_FAILED";
